import { ReactElement, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PrivateLayout from '@/layouts/PrivateLayout';
import { Helmet } from 'react-helmet-async';
import TimeClockPanel from '@/features/timeProgress/TimeClockPanel';
import TimeProgressPanel from '@/features/timeProgress/TimeProgressPanel';
import PanelContents from '@/layouts/panelContents/PanelContents';
import MainContentsLayout from '@/layouts/MainContentsLayout';
import Advertisement from '@/features/advertisement/Advertisement';
import ActivityCalendar from '@/features/activityCalendar/ActivityCalendar';
import Memo from '@/features/memo/Memo';
import UserReferralInfo from '@/features/userReferral/UserReferralInfo';
import SimpleAnalyticsPanel from '@/features/simpleAnalytics/SimpleAnalyticsPanel';
import FirstTimeExperienceManager from '@/features/firstTimeExperience/FirstTimeExperienceManager';
import { useUser } from '@/hooks/UserContext';
import 'react-calendar/dist/Calendar.css';

/**
 * デスクページ
 * @returns
 */
function Desk(): ReactElement {
    const { t } = useTranslation('desk');
    const { userInfo } = useUser();
    /**
     * 表示するパネル設定
     * 各コンポーネントを呼び出す
     */
    const componentMap: Record<string, React.ReactNode> = {
        // 時間表示
        hmTimeClock: <TimeClockPanel />,
        // 進捗表示
        hmTimeProgress: <TimeProgressPanel />,
        // シンプル分析
        hmSimpleAnalytics: <SimpleAnalyticsPanel />,
        // アクティビティビュー
        hmActivityCalendar: <ActivityCalendar />,
        // メモ
        hmMemo: <Memo />,
        // 紹介情報（紹介者は常時表示、その他ユーザーにも表示）
        hmReferral: <UserReferralInfo />,
        // 広告
        hmAd: <Advertisement />,
    };

    // メイン処理
    useEffect(() => {
        // 不要になったローカルストレージを削除（2025年９月に削除予定）
        localStorage.removeItem('homePageData');
    }, []);

    /**
     * レンダリング
     */
    return (
        <FirstTimeExperienceManager userInfo={userInfo}>
            <Helmet>
                <title>{t('meta.title')}</title>
            </Helmet>
            <PrivateLayout>
                <MainContentsLayout>
                    <PanelContents componentMap={componentMap} />
                </MainContentsLayout>
            </PrivateLayout>
        </FirstTimeExperienceManager>
    );
}

export default Desk;
